<template>
  <div class="big-buttons row">
    <div
      class="col-12 col-lg mb-6 pb-3"
      v-for="(option, index) in options"
      :key="index"
    >
      <div
        class="big-button"
        :class="{
          active: value === option.id,
          inactive: value !== option.id,
          login: login
        }"
        @click="$emit('input', option.id)"
      >
        <img :src="option.src" :alt="option.name" />
        <span class="button-name" :class="{ login }">{{ option.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    login: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.big-buttons {
  .big-button {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 315px;
    padding: 0 12px;
    border-radius: 6px;
    text-align: center;
    border: 1px solid #d7d7d7;
    transition: 0.2s all ease-in-out;
    background: rgba(255, 255, 255, 1);

    &.login {
      border: 1px solid var(--semantic-neutral-100, #2b2b2b);
      background: var(--surface-cumulative-plus-8, rgba(39, 39, 53, 0.23));
      &:hover {
        background: var(--surface-cumulative-plus-20, rgba(39, 39, 53, 0.56));
        border: 1px solid var(--semantic-neutral-100, #2b2b2b);
      }
      &.active {
        border: 1px solid var(--semantic-primary-accent-500, #9341ff);
        background: var(--surface-cumulative-plus-20, rgba(39, 39, 53, 0.56));
      }
    }
    &:hover,
    &.active {
      box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.08);
      background-color: rgba(255, 255, 255, 0.96);
      border: 1px solid rgba(207, 174, 255, 0.86);
      cursor: pointer;
    }
    .button-name {
      transition: 0.2s font-weight;
      &.login {
        color: var(--semantic-neutral-1000, #f0f0f0);
        max-width: 176px;
        font-size: 14px;
        padding-top: 40px;
      }
    }
  }
}
</style>
